import React from 'react';
import { ArrowLeft, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function TermsOfUsePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-8">
      <div className="mx-auto max-w-4xl bg-white rounded-xl shadow-sm overflow-hidden">
        <div className="p-6 md:p-8 border-b border-gray-100 flex items-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <ArrowLeft className="h-5 w-5 text-gray-500" />
          </button>
          <div className="flex items-center gap-3">
            <div className="p-2 bg-blue-50 text-blue-600 rounded-lg">
              <FileText className="h-6 w-6" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900">Termos de Uso</h1>
          </div>
        </div>

        <div className="p-6 md:p-8 prose prose-blue max-w-none text-gray-600">
          <p className="lead text-lg text-gray-700 mb-8">
            Bem-vindo ao Portal do Associado Multiveicular. Ao utilizar nosso aplicativo e nossos serviços, você concorda com estes termos de uso.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">1. Aceitação dos Termos</h2>
          <p>
            Ao acessar e utilizar este sistema, você confirma que leu, compreendeu e concorda em ficar vinculado a estes Termos de Uso e à nossa Política de Privacidade.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">2. Uso do Portal</h2>
          <p>
            O portal deve ser utilizado exclusivamente para fins lícitos, relacionados à gestão de sua proteção automotiva e acesso aos serviços oferecidos pela Multiveicular. É expressamente proibido:
          </p>
          <ul className="list-disc pl-6 space-y-2 mb-6">
            <li>Fornecer informações falsas ou de terceiros;</li>
            <li>Tentar acessar áreas restritas do sistema não destinadas ao seu perfil de usuário;</li>
            <li>Utilizar o portal de forma que possa danificar, inutilizar ou sobrecarregar nossos servidores.</li>
          </ul>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">3. Responsabilidades do Associado</h2>
          <p>
            Você é responsável por manter a confidencialidade de suas credenciais de acesso (login e senha) e por todas as atividades que ocorrerem sob sua conta. Notifique-nos imediatamente sobre qualquer uso não autorizado.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">4. Prestação de Serviços</h2>
          <p>
            A utilização deste portal não isenta o associado do cumprimento das obrigações previstas no regulamento do Programa de Benefícios Multiveicular, incluindo o pagamento pontual das mensalidades e faturas.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">5. Propriedade Intelectual</h2>
          <p>
            Todo o conteúdo, design e funcionalidades deste portal são de propriedade exclusiva da Multiveicular, sendo protegidos pelas leis de direitos autorais e propriedade intelectual aplicáveis.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">6. Alterações nos Termos</h2>
          <p>
            A Multiveicular reserva-se o direito de atualizar ou modificar estes Termos de Uso a qualquer momento, sem aviso prévio. A continuação do uso do portal após eventuais alterações constitui a aceitação dos novos termos.
          </p>
          
          <div className="mt-12 pt-6 border-t border-gray-100 text-sm text-gray-400 text-center">
            Última atualização: {new Date().toLocaleDateString('pt-BR')}
          </div>
        </div>
      </div>
    </div>
  );
}
